<template>
  <div class='yxtbiz-consult-wrapper'>
    <template v-if="isTelConsult">
      <yxt-button
        :type='btnType'
        round
        :class="['consult-btn', 'consult-btn-tel', size, {active: active}]"
        :size="size"
        @click="showTelPopup"
        v-bind="$attrs"
      >
        {{ $t('pc_biz_btn_phoneCall') /** 电话咨询 */ }}
      </yxt-button>

      
        <yxt-dialog :visible.sync="telVisible" :title="$t('pc_biz_lbl_tel') /** 咨询电话 */">
          <div class="tel-section">
            <div>{{ $t('pc_biz_lbl_tel') /** 咨询电话 */}}：{{phone}}</div>
          </div>
        </yxt-dialog>
    </template>

    <template v-else>
      <yxt-button
        @click="handleConsult"
        :size="size"
        :type='btnType'
        :round="isRound"
        :class="isNoCustom ? '' : ['consult-btn', size, { active: active }]"
        v-bind="$attrs"
      >
        {{ consultBtnText }}
      </yxt-button>

      <yxt-dialog
          :title="$t('pc_biz_ttl_addFriend' /** 加好友 */)"
          class='qr-popup'
          closeable="outer"
          :visible.sync="visible"
      >
        <yxt-image
          radius='8'
          class='qr-image'
          :src="qrCodeUrl"
        />
        <div class='qr-tips'>
          <div>{{ $t('pc_biz_tip_scanToConsult') /** 扫码联系学习顾问咨询 */}}</div>
          <div>{{ $t('pc_biz_lbl_tel') /** 咨询电话 */}}：{{phone}}</div>
        </div>
      </yxt-dialog>
    </template>
  </div>
</template>

<script>

// 用script加载独立js文件，测试有执行相关代码
// import 'dingtalk-jsapi/entry/mobile'

// 用 dd.biz.util.openLink
// import openLink from 'dingtalk-jsapi/api/biz/util/openLink'

import { getDingdingCorpId } from './service';
import { SERVE_GROUP_CONF, DING_SDK_URL, APPID_CONF, STATIC_BASE_URL } from './config';
import { loadScript } from 'yxt-biz-pc/src/utils/util';
import { getOpenPlats, appClient, isMobile } from './common';

export default {
  name: 'YxtbizConsult',
  props: {
    active: Boolean,
    btnType: {
      type: String,
      default: 'second'
    },
    phone: {
      type: String,
      default: '400-998-6980'
    },
    type: {
      type: String,
      default: 'online' //  online or tel 在线咨询 或 电话咨询
    },
    size: {
      type: String,
      default: 'large'
    },
    isRound: {
      type: Boolean,
      default: true
    },
    isNoCustom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      qrCodeUrl: STATIC_BASE_URL + 'assets/d49f79dc/00cf95f4/qrcode.JPG',
      visible: false,
      telVisible: false,
      corpId: '',
      loading: false
    };
  },
  methods: {
    showTelPopup() {
      this.telVisible = true;
    },
    displayLoading(ms = 1500) {
      this.loading = true;
      setTimeout(() => (this.loading = false), ms);
    },
    openLink() {
      const env = window.feConfig && window.feConfig.apiEnv || 'dev';
      if (this.isFSISV) {
        const urls = SERVE_GROUP_CONF.feishu.urls;
        const link = urls[env];
        return window.open(link);
      }

      if (this.isDDISV) {
        const ddGroup = SERVE_GROUP_CONF.dingding;
        const appId = APPID_CONF.dingding[env] || 'dev';
        const corpId = this.corpId;
        const url = `https://page.dingtalk.com/wow/dingtalk/act/serviceconversation?wh_biz=tm&showmenu=false&goodsCode=${ddGroup.goodsCode}&corpId=${corpId}&token=${ddGroup.token}`;
        if (window.dd) {
          if (isMobile) {
            window.dd.biz.util.openLink({ url });
          } else {
            const dingUrl = `dingtalk://dingtalkclient/action/openapp?corpid=${corpId}&container_type=work_platform&app_id=${appId}&redirect_type=emit_params&params=&redirect_url=${encodeURIComponent(url)}`;
            location.href = dingUrl; // 唤起钉钉客户端打开链接
          }
        } else {
          console.error('DINGTALK-SDK未加载');
          this.$message.error('SDK未加载');
        }
      }
    },
    getAppName() {
      let name = 'APP';
      switch (true) {
        case this.isDDISV:
          name = '钉钉APP';
          break;
        case this.isFSISV:
          name = '飞书APP';
          break;
        case this.isQWISV:
          name = '企微APP';
      }
      return name;
    },
    checkAppClient() {
      const isApp = appClient.dingtalk || appClient.feishu || appClient.wxwork;
      if (!isApp) {
        this.$message.error(
          this.$t('pc_biz_msg_useApp', { 0: this.getAppName() })
        ); /** 请在{0}打开 */
      }
      return isApp;
    },
    async handleConsult() {
      if (!this.checkAppClient()) {
        return;
      }

      if (this.isFSISV) {
        this.displayLoading();
        this.$emit('join');
        return this.openLink();
      }

      if (this.isDDISV) {
        const corpId = await this.getCorpId();
        if (corpId) {
          this.$emit('join');
          return this.openLink();
        }
      }

      // 加好友咨询
      this.$emit('join');
      this.showPopup();
    },
    // 获取coreId
    async getCorpId() {
      this.loading = true;
      const orgId = localStorage.orgId;

      try {
        const res = await getDingdingCorpId(orgId);
        if (res.corpId) {
          this.corpId = res.corpId;
          return this.corpId;
        }
        throw new Error('res没有返回corpId');
      } catch (err) {
        console.error('getDingdingCorpId:', err);
        this.$message.error('获取corpId失败');
      }

      this.loading = false;
      return this.corpId;
    },
    showPopup() {
      // 加好友咨询
      this.visible = true;
    },
    hidePopup() {
      this.visible = false;
    },
    updateVisible(visible) {
      this.visible = visible;
    },
    phoneCall() {
      this.$emit('call');
    },
    async join() {
      return await this.handleConsult();
    },
    async tel() {
      this.showTelPopup();
    },
    showQrCode() {
      return this.showPopup();
    }
  },
  async created() {
    const { isDDISV, isFSISV, isQWISV } = getOpenPlats();
    this.isDDISV = isDDISV;
    this.isFSISV = isFSISV;
    this.isQWISV = isQWISV;

    const consultType = isDDISV || isFSISV ? 'group' : 'friend';

    this.isGroupConsult = consultType === 'group';
    this.consultBtnText = this.isGroupConsult
      ? this.$t('pc_biz_btn_joinGroup') /* 入群咨询 */
      : this.$t('pc_biz_btn_makeFriends'); /* 加好友咨询 */

    this.isTelConsult = this.type === 'tel';

    if (isDDISV && !window.dd && !this.isTelConsult) {
      const ok = await loadScript(DING_SDK_URL, true);
      if (!ok) {
        // 重试
        await loadScript(DING_SDK_URL, true);
      }
    }

    // console.vm = this;
  }
};
</script>
